import { Injectable } from '@angular/core';
import { ID, QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { SalesOrderItem } from '../model/sales-order-item.model';
import { SalesOrderItemStore, SalesOrderItemState } from '../store/sales-order-item.store';

@Injectable({ providedIn: 'root' })
export class SalesOrderItemQuery<T extends SalesOrderItem> extends QueryEntity<SalesOrderItemState<T>> {
  constructor(protected override store: SalesOrderItemStore<T>) {
    super(store);
  }

  selectByOrderId(id: number | ID): Observable<T[]> {
    return this.selectAll({
      filterBy: ({ lngOrderID }) => lngOrderID === id,
    });
  }

  hasItemsByOrderId(id: number | ID): boolean {
    return !!this.getAll({
      filterBy: ({ lngOrderID }) => lngOrderID === id,
    }).length;
  }
}
